import './bootstrap.js'

import { createApp } from 'vue';
import App from './App.vue';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import FocusTrap from 'primevue/focustrap';
import Tooltip from 'primevue/tooltip';
import router from './router';
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import { Chart } from 'chart.js/auto';
import ptBR from './../lang/pt_BR.json';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css'
import '../css/app.css';

import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'


const app = createApp(App);

const applyChartThemeDefaults = () => {
    const isDark = document.documentElement.classList.contains('my-app-dark');
    Chart.defaults.color = isDark ? '#e5e7eb' : '#334155';
    Chart.defaults.borderColor = isDark ? '#374151' : '#e2e8f0';
    // Muitos gráficos da aplicação não definem cor por dataset;
    // força o plugin de paleta automática para manter as cores visíveis.
    if (Chart.defaults.plugins?.colors) {
        Chart.defaults.plugins.colors.enabled = true;
        Chart.defaults.plugins.colors.forceOverride = true;
    }
};

applyChartThemeDefaults();
window.addEventListener('theme-changed', applyChartThemeDefaults);

app.use(router);
app.use(ToastService);
app.use(ConfirmationService);
app.directive('tooltip', Tooltip);
app.directive('focustrap', FocusTrap);
app.use(PrimeVue,{
    locale: ptBR,
    theme: {
        preset: Aura,
        options: {
            darkModeSelector: '.my-app-dark',
        }
    }
});

app.mount('#app');